module.exports = __webpack_public_path__ + "9d4c421fbf0c42485d1db2460e53cb4e.jpg";